/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

export type Int64 = string | number;

export enum EntityType {
  Project = 1,
  Bot = 2,
}

export enum EventConnectorPublishResult {
  /** 审核中 */
  Auditing = 1,
  /** 成功 */
  Success = 2,
  /** 失败 */
  Failed = 3,
}

export enum EventType {
  Create = 1,
  Update = 2,
  Delete = 3,
  Publish = 4,
}
/* eslint-enable */
